/* HOD 3.9.2 homepage interactions (design v2, 8/24):
   hero carousel · flash-banner countdown · Get Inspired spotlight (v3 9/29) ·
   Better Bought Together hotspots. Vanilla, no deps. */
(function () {
  'use strict';
  /* several sections include this file — classic scripts execute once per tag,
     which would double-bind every listener (toggles cancel out, adds multi-fire) */
  if (window.__hodHomeInit) return;
  window.__hodHomeInit = true;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INIT = new WeakSet();   /* per-root init guard as a JS property, never an attribute (attributes survive an innerHTML re-render) */

  /* ---------------- HERO CAROUSEL ----------------
     initHero(root) is per section root (guarded on the root, not the page) so the theme editor's
     re-render of the section on every setting change gets live controls again (shopify:section:load),
     and editing a slide block jumps the carousel to that slide and holds it there (shopify:block:select)
     — Stas 9/29: "every time I make a minor change it reverts to the first slide and won't let me go to
     the third slide until I save". */
  function initHero(root) {
    if (INIT.has(root)) return;
    INIT.add(root);
    var slides = root.querySelectorAll('[data-hp-slide]');
    if (slides.length < 2) { root.querySelector('[data-hp-hero-controls]') && (root.querySelector('[data-hp-hero-controls]').hidden = true); return; }
    var dots = root.querySelectorAll('[data-hp-dot]');
    var playBtn = root.querySelector('[data-hp-play]');
    var interval = parseInt(root.getAttribute('data-hp-interval') || '6000', 10);
    var cur = 0, timer = null, playing = !REDUCED, held = false;
    /* theme editor: every setting change re-renders the section; remember the slide being edited so it does not
       start over at slide 1 and animate back (Stas 10/1) */
    var memKey = 'hod-hero-cur:' + (root.closest('.shopify-section') ? root.closest('.shopify-section').id : 'x');
    var editing = !!(window.Shopify && window.Shopify.designMode);
    if (editing) { try { var saved = parseInt(sessionStorage.getItem(memKey), 10); if (saved >= 0 && saved < slides.length) { cur = saved; held = true; } } catch (e) {} }
    function instant(fn) { slides.forEach(function (s) { s.style.transition = 'none'; }); fn(); void root.offsetWidth; slides.forEach(function (s) { s.style.transition = ''; }); }

    function paint() {
      slides.forEach(function (s, i) {
        s.style.transform = 'translateX(' + ((i - cur) * 100) + '%)';
        s.setAttribute('aria-hidden', i === cur ? 'false' : 'true');
        // keep links unfocusable on hidden slides (and focusable on the active one)
        s.querySelectorAll('a').forEach(function (a) { if (i === cur) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    }
    function syncPlayBtn() {
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', playing ? 'false' : 'true');
      playBtn.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
      playBtn.classList.toggle('is-paused', !playing);
    }
    function tickStart() { clearInterval(timer); if (playing && !held && !document.hidden) { timer = setInterval(function () { cur = (cur + 1) % slides.length; paint(); }, interval); } }
    function go(i) { cur = (i + slides.length) % slides.length; paint(); tickStart(); }

    root.querySelectorAll('[data-hp-prev]').forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    root.querySelectorAll('[data-hp-next]').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    if (playBtn) playBtn.addEventListener('click', function () { playing = !playing; held = false; syncPlayBtn(); tickStart(); });
    document.addEventListener('visibilitychange', tickStart);
    /* theme editor: show the slide being edited and stop the rotation while it is selected */
    root.__hpHeroSelect = function (el, hold) {
      var i = Array.prototype.indexOf.call(slides, el);
      if (i < 0) return;
      held = !!hold;
      if (editing) { try { sessionStorage.setItem(memKey, String(i)); } catch (e) {} }   /* remember the slide the editor selected */
      if (i === cur) { tickStart(); return; }
      instant(function () { go(i); });   /* jump, no slide animation, while editing */
    };
    root.__hpHeroRelease = function () { held = false; if (editing) { try { sessionStorage.removeItem(memKey); } catch (e) {} } tickStart(); };
    if (editing) { instant(paint); } else { paint(); }
    syncPlayBtn(); tickStart();
  }
  document.querySelectorAll('[data-hp-hero]').forEach(initHero);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-hp-hero]').forEach(initHero); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-hp-hero]'); var slide = e.target.closest('[data-hp-slide]');
      if (root && slide && root.__hpHeroSelect) root.__hpHeroSelect(slide, true);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest('[data-hp-hero]');
      if (root && root.__hpHeroRelease) root.__hpHeroRelease();
    });
  }

  /* ---------------- COUNTDOWN ---------------- */
  function initCountdown(box) {
    if (INIT.has(box)) return;
    INIT.add(box);
    /* data-end is either an epoch in seconds (Liquid `date: '%s'`, store time — every visitor sees the same end)
       or a date string (older sections); the string form is parsed in the visitor's zone */
    var raw = (box.getAttribute('data-end') || '').trim();
    var end = /^\d{9,}$/.test(raw) ? Number(raw) * 1000 : new Date(raw).getTime();
    if (isNaN(end)) { box.hidden = true; return; }
    var cells = {
      d: box.querySelectorAll('[data-cd="d"] b'), h: box.querySelectorAll('[data-cd="h"] b'),
      m: box.querySelectorAll('[data-cd="m"] b'), s: box.querySelectorAll('[data-cd="s"] b')
    };
    function p2(n) { return String(n).padStart(2, '0'); }
    function set(pair, val) { if (pair.length === 2) { pair[0].textContent = val[0]; pair[1].textContent = val[1]; } }
    /* Stas 9/6: when the countdown reaches zero the whole flash block disappears (section wrapper) */
    var section = box.closest('.shopify-section') || box.closest('.hod-hp__wrap') || box;
    /* 10/1: a box with data-cd-keep (sale banner) hides only itself at zero — the banner stays up */
    var target = box.hasAttribute('data-cd-keep') ? box : section;
    var iv = null;
    function tick() {
      if (!box.isConnected) { clearInterval(iv); return; }   /* the editor re-rendered the section; the new box gets its own init */
      var diff = Math.max(0, end - Date.now());
      if (diff <= 0) { if (!(window.Shopify && window.Shopify.designMode)) target.hidden = true; clearInterval(iv); return; }
      set(cells.d, p2(Math.min(99, Math.floor(diff / 864e5))));
      set(cells.h, p2(Math.floor(diff / 36e5) % 24));
      set(cells.m, p2(Math.floor(diff / 6e4) % 60));
      set(cells.s, p2(Math.floor(diff / 1e3) % 60));
    }
    tick(); iv = setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-hp-countdown]').forEach(initCountdown);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-hp-countdown]').forEach(initCountdown); });
  }

  /* ---------------- GET INSPIRED SPOTLIGHT (v3, Stas 9/29) ----------------
     Desktop: the active card is wide in the centre, its neighbours narrow-ish at the sides (cut by the
     viewport), everything else parked off-screen on its own side; the track LOOPS so there is always a
     previous and a next (3 visible). A nav re-slots every card and they glide one slot along the same axis;
     a card that would have to cross the stage (the far side wrapping round) first fades out on its own
     side, is moved silently, then slides in. Mobile (≤820px) keeps the swipe row. Re-initialised on
     shopify:section:load so the theme editor stays live. */
  function initInsp(root) {
    if (INIT.has(root)) return;
    INIT.add(root);
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hp-insp-card]'));
    if (!cards.length) return;
    var mqMobile = window.matchMedia('(max-width: 820px)');
    var row = root.querySelector('.hod-insp__row');
    var scrim = root.querySelector('[data-hp-insp-scrim]');
    var isPopout = root.classList.contains('hod-insp--popout');   /* 10/19 (Stas): section setting — desktop list as a modal over the greyed page */
    var bar = root.querySelector('[data-hp-insp-bar]');
    var bchips = bar ? Array.prototype.slice.call(bar.querySelectorAll('[data-hp-insp-bchip]')) : [];   /* 10/19 (Stas): phones — chip under the photo, one per look */
    var SLOTS = ['is-prev', 'is-next', 'is-far-left', 'is-far-right', 'is-leaving'];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // product list is closed by default everywhere (Stas 9/1); the chip toggles it
    var cur = 0, cardOpen = false, pendingT = [];
    function setVw() { if (row) row.style.setProperty('--insp-vw', document.documentElement.clientWidth + 'px'); }
    setVw();
    function paint() {
      cards.forEach(function (c, i) {
        var on = i === cur;
        c.classList.toggle('is-on', on);
        var pop = c.querySelector('[data-hp-insp-pop]');
        if (pop) {
          pop.hidden = !(on && cardOpen);
          if (pop.hidden) pop.removeAttribute('aria-modal');
          else if (mqMobile.matches || isPopout) pop.setAttribute('aria-modal', 'true');
        }
        var btn = c.querySelector('[data-hp-insp-open]');
        if (btn) btn.setAttribute('aria-expanded', on && cardOpen ? 'true' : 'false');
      });
      bchips.forEach(function (b, i) { var on = i === cur; b.classList.toggle('is-on', on); if (b.tagName === 'BUTTON') b.setAttribute('aria-expanded', on && cardOpen ? 'true' : 'false'); });
      if (scrim) scrim.hidden = !(cardOpen && (mqMobile.matches || isPopout));   /* phones: sheet scrim; desktop: only the pop-out style greys the page */
      root.classList.toggle('is-open', cardOpen);
    }
    /* circular offset of card i from the active one, folded into a window centred on 0
       (n=3 → -1,0,1 · n=4 → -1,0,1,2 · n=5 → -2..2 · n=6 → -2..3) */
    function offset(i) {
      var n = cards.length, off = ((i - cur) % n + n) % n;
      if (n >= 3 && off > n / 2) off -= n;
      return off;
    }
    function slotFor(off) { return off === 0 ? 'is-on' : off === -1 ? 'is-prev' : off === 1 ? 'is-next' : off < 0 ? 'is-far-left' : 'is-far-right'; }
    function side(slot) { return slot === 'is-prev' || slot === 'is-far-left' ? 'L' : slot === 'is-next' || slot === 'is-far-right' ? 'R' : 'C'; }
    function apply(c, slot) {
      SLOTS.forEach(function (k) { c.classList.remove(k); });
      c.classList.toggle('is-on', slot === 'is-on');
      if (slot !== 'is-on') c.classList.add(slot);
      c.dataset.inspSlot = slot;                                   /* the slot of record — paint() may strip is-on before shift() reads it */
      var far = slot === 'is-far-left' || slot === 'is-far-right';
      var chip = c.querySelector('[data-hp-insp-open]');
      if (chip) { chip.tabIndex = far ? -1 : 0; if (far) chip.setAttribute('aria-hidden', 'true'); else chip.removeAttribute('aria-hidden'); }
    }
    function silently(c, fn) { c.classList.add('no-anim'); fn(); void c.offsetWidth; c.classList.remove('no-anim'); }
    function shift(instant) {
      if (!row) return;
      var prevBtn = root.querySelector('[data-hp-insp-prev]'), nextBtn = root.querySelector('[data-hp-insp-next]');
      pendingT.forEach(clearTimeout); pendingT = [];
      if (mqMobile.matches) {
        cards.forEach(function (c) { SLOTS.forEach(function (k) { c.classList.remove(k); }); var chip = c.querySelector('[data-hp-insp-open]'); if (chip) { chip.tabIndex = 0; chip.removeAttribute('aria-hidden'); } });
        if (prevBtn) prevBtn.removeAttribute('data-disabled');
        if (nextBtn) nextBtn.removeAttribute('data-disabled');
        return;
      }
      cards.forEach(function (c, i) {
        var was = c.dataset.inspSlot || SLOTS.concat(['is-on']).filter(function (k) { return c.classList.contains(k) && k !== 'is-leaving'; })[0] || 'is-on';
        var now = slotFor(offset(i));
        if (instant) { silently(c, function () { apply(c, now); }); return; }
        if (!reduce && side(was) !== 'C' && side(now) !== 'C' && side(was) !== side(now)) {
          /* wrapping round to the other side */
          var farNew = side(now) === 'L' ? 'is-far-left' : 'is-far-right';
          var enter = function () { silently(c, function () { apply(c, farNew); }); if (now === 'is-prev' || now === 'is-next') apply(c, now); };
          if (was === 'is-prev' || was === 'is-next') {
            /* visible: exit on the old side first, then jump silently and enter from the new side */
            apply(c, side(was) === 'L' ? 'is-far-left' : 'is-far-right');
            c.classList.add('is-leaving');
            pendingT.push(setTimeout(enter, 420));
          } else {
            enter();                                               /* already hidden: just switch sides and slide in */
          }
          return;
        }
        apply(c, now);
      });
      var one = cards.length < 2;
      root.querySelectorAll('[data-hp-insp-prev], [data-hp-insp-next]').forEach(function (b) { b.toggleAttribute('data-disabled', one); });
    }
    /* 10/6 (Stas): the card photos are lazy backgrounds (custom.js, loaded when a card nears the viewport) — parked
       side cards sit outside it, so the next photo used to start downloading only as it slid in. Warm the two cards
       on each side of the active one ahead of time (and the next two as you swipe on phones). */
    function warm(c) {
      if (!c || !c.hasAttribute('data-hod-bg')) return;
      if (window.hodBgApply) { window.hodBgApply(c); return; }
      var m = mqMobile.matches && c.getAttribute('data-hod-bg-m');
      var x2 = (window.devicePixelRatio || 1) > 1.5 && c.getAttribute('data-hod-bg-2x');
      var u = m || x2 || c.getAttribute('data-hod-bg');
      c.removeAttribute('data-hod-bg');
      if (u) c.style.backgroundImage = 'url("' + u + '")';
    }
    function warmAround() {
      var n = cards.length;
      [0, -1, 1, -2, 2].forEach(function (d) { warm(cards[((cur + d) % n + n) % n]); });
    }
    function warmRow() {
      if (!row) return;
      var edge = row.scrollLeft + row.clientWidth * 2.2;
      cards.forEach(function (c) { if (c.offsetLeft < edge) warm(c); });
    }
    function scrollToCard(i, instant) {
      if (!row || !cards[i]) return;
      var x = cards[i].getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - 10;   /* the row scrolls with 10px side padding (scroll-padding) */
      row.scrollTo({ left: x, behavior: (reduce || instant) ? 'auto' : 'smooth' });
    }
    function activate(i, open) { cur = i; cardOpen = open !== false; shift(); paint(); warmAround(); if (mqMobile.matches && !cardOpen) scrollToCard(i); }
    function curFromScroll() { if (!row || !cards[0]) return cur; var w = cards[0].getBoundingClientRect().width + 10, i = Math.round(row.scrollLeft / w); return Math.max(0, Math.min(cards.length - 1, i)); }
    function closeTray() {
      if (mqMobile.matches) { var ci = curFromScroll(); if (ci !== cur) { cur = ci; } }   /* review 10/19: the sheet may have opened mid-fling — follow the look actually in view */
      var c = cards[cur];
      var pop = c && c.querySelector('[data-hp-insp-pop]');
      var wasInside = pop && pop.contains(document.activeElement);
      cardOpen = false; paint();
      if (wasInside) {
        var chip = (mqMobile.matches && bchips[cur] && bchips[cur].tagName === 'BUTTON') ? bchips[cur] : c.querySelector('[data-hp-insp-open]');
        if (chip) chip.focus({ preventScroll: true });
      }
    }
    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('[data-hp-insp-open]')) return; // the chip has its own handler
        if (e.target.closest('[data-hp-insp-pop]') && !e.target.closest('[data-hp-insp-close]')) return;
        if (e.target.closest('[data-hp-insp-close]')) { closeTray(); return; }
        if (i !== cur) { if (mqMobile.matches) scrollToCard(i); else activate(i, false); } // side-card click brings it to the centre (10/19: phones scroll the row to it); the chip opens the product list
      });
      var btn = c.querySelector('[data-hp-insp-open]');
      if (btn) {
        var toggleFromChip = function () {
          if (cur === i && cardOpen) { closeTray(); return; } // second click closes
          activate(i, true);
          var x = c.querySelector('[data-hp-insp-close]');
          if (x) x.focus({ preventScroll: true });
        };
        btn.addEventListener('click', function (e) { e.stopPropagation(); toggleFromChip(); });
        btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleFromChip(); } });
      }
    });
    if (scrim) scrim.addEventListener('click', closeTray);
    bchips.forEach(function (b, i) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (i !== cur) { scrollToCard(i); return; }
        if (cardOpen) { closeTray(); return; }
        activate(i, true);
        var x = cards[i].querySelector('[data-hp-insp-close]');
        if (x) x.focus({ preventScroll: true });
      });
    });
    /* review 10/19: keep Tab inside the open list (it is aria-modal on every width) — wrap from Shop all / the last row back to the × and the other way round */
    cards.forEach(function (c) {
      var pop = c.querySelector('[data-hp-insp-pop]');
      if (!pop) return;
      pop.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(pop.querySelectorAll('a[href], button:not([disabled])'), function (el) { return el.offsetParent !== null || el.getClientRects().length; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cardOpen) closeTray(); });   /* 10/15: Escape closes the product list on desktop too (it now covers half the card) */
    var navTarget = null;
    function nav(dir) {
      if (mqMobile.matches && row && cards[0]) {
        var base = navTarget === null ? curFromScroll() : navTarget;                         /* review 10/19: taps accumulate whole cards even mid-animation */
        var n = cards.length, t = base + dir, wrap = t < 0 || t >= n;                        /* 10/19 (Stas): the arrows loop first ↔ last like the PDP looks bar — a wrap is a hard cut, not a rewind */
        navTarget = ((t % n) + n) % n;
        scrollToCard(navTarget, wrap);
      } else if (cards.length > 1) {
        activate((cur + dir + cards.length) % cards.length, false);
      }
    }
    root.querySelectorAll('[data-hp-insp-prev]').forEach(function (b) { b.addEventListener('click', function () { nav(-1); }); });
    root.querySelectorAll('[data-hp-insp-next]').forEach(function (b) { b.addEventListener('click', function () { nav(1); }); });
    /* 10/1 (Stas): horizontal trackpad / mouse-wheel swipes and mouse drags move the track too (desktop; phones scroll natively) */
    var wheelAcc = 0, wheelLocked = false, wheelLast = 0, wheelDir = 0, wheelPeak = 0, wheelPrev = 0, wheelDecay = false, wheelDown = 0;
    root.addEventListener('wheel', function (e) {
      if (e.target.closest && e.target.closest('[data-hp-insp-pop]')) return;   /* 10/15: the open product list scrolls on its own — same exemption as the drag below */
      if (mqMobile.matches) return;
      if (cardOpen && isPopout) { e.preventDefault(); return; }       /* review 10/19: the greyed page behind the pop-out modal is inert — no swipe-to-next, no scrolling under the panel */
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;          /* vertical scrolling passes through */
      e.preventDefault();
      var now = Date.now(), mag = Math.abs(e.deltaX);
      /* 10/1 (Stas, iPad): trackpads coast for 1-2 s with no 150 ms gap, so a second swipe in the same direction was
         swallowed as inertia. Deltas that have been decaying and suddenly jump = a new finger push = a new gesture. */
      var fresh = wheelLocked && wheelDecay && mag > 12 && mag > wheelPrev * 1.8;
      if (now - wheelLast > 150 || fresh) { wheelAcc = 0; wheelLocked = false; } /* a pause ends the gesture (inertia events arrive 8-17 ms apart) */
      wheelLast = now;
      if (wheelLocked) {
        if (mag > wheelPeak) wheelPeak = mag;
        wheelDown = mag < wheelPrev ? wheelDown + 1 : 0;                      /* three falling samples = a real inertia tail, not one slow frame mid-swipe (review 10/1) */
        if (wheelDown >= 3 && mag < wheelPeak * 0.5) wheelDecay = true;
        wheelPrev = mag;
        if (e.deltaX * wheelDir < 0) { wheelLocked = false; wheelAcc = 0; } else return;   /* swallow the inertia tail; a reversal starts a new gesture */
      }
      wheelPrev = mag;
      wheelAcc += e.deltaX;
      if (Math.abs(wheelAcc) > 60) { wheelDir = wheelAcc > 0 ? 1 : -1; nav(wheelDir); wheelAcc = 0; wheelLocked = true; wheelPeak = mag; wheelDecay = false; wheelDown = 0; }
    }, { passive: false });
    var dragX = null, dragMoved = false;
    root.addEventListener('pointerdown', function (e) { if (mqMobile.matches || e.pointerType !== 'mouse' || e.button !== 0) return; if (cardOpen && isPopout) return; if (e.target.closest('button, a, [data-hp-insp-pop]')) return; dragX = e.clientX; dragMoved = false; });   /* review 10/19: no drag-to-next behind the pop-out modal */
    root.addEventListener('pointermove', function (e) { if (dragX === null) return; if (Math.abs(e.clientX - dragX) > 40 && !dragMoved) { dragMoved = true; nav(e.clientX < dragX ? 1 : -1); } });
    var dragEnd = function () { if (dragMoved) { var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); root.removeEventListener('click', stop, true); }; root.addEventListener('click', stop, true); setTimeout(function () { root.removeEventListener('click', stop, true); }, 0); } dragX = null; dragMoved = false; };
    root.addEventListener('pointerup', dragEnd); root.addEventListener('pointercancel', dragEnd); root.addEventListener('pointerleave', dragEnd);
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', function () { cardOpen = false; cur = 0; if (row) row.scrollLeft = 0; shift(true); paint(); });
    var rzT = null;
    window.addEventListener('resize', function () { clearTimeout(rzT); rzT = setTimeout(setVw, 80); });
    root.__hpInspActivate = function (i) { if (i >= 0 && i < cards.length) activate(i, false); };
    shift(true); paint();
    warmAround();
    if (row) {
      var warmT = null, curT = null, settleT = null;
      row.addEventListener('scroll', function () {
        if (!mqMobile.matches) return;
        clearTimeout(settleT); settleT = setTimeout(function () { navTarget = null; }, 160);   /* a finished (or finger-interrupted) scroll clears the arrow target */
        /* 10/19: the look in view drives the chip under the photo */
        if (!curT) curT = setTimeout(function () {
          curT = null;
          var w = cards[0].getBoundingClientRect().width + 10, i = Math.round(row.scrollLeft / w);
          if (navTarget !== null && i === navTarget) navTarget = null;
          if (i !== cur && i >= 0 && i < cards.length && !cardOpen) { cur = i; paint(); }
        }, 60);
        if (warmT) return;
        warmT = setTimeout(function () { warmT = null; warmRow(); }, 80);
      }, { passive: true });
      if (mqMobile.matches) warmRow();
    }
  }
  document.querySelectorAll('[data-hp-insp]').forEach(initInsp);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-hp-insp]').forEach(initInsp); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-hp-insp]'); if (!root || !root.__hpInspActivate) return;
      var i = Array.prototype.indexOf.call(root.querySelectorAll('[data-hp-insp-card]'), e.target.closest('[data-hp-insp-card]'));
      root.__hpInspActivate(i);
    });
  }

  /* ---------------- BETTER BOUGHT TOGETHER ---------------- */
  document.querySelectorAll('[data-hp-bbt]').forEach(function (root) {
    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-hp-spot]'));
    var mqM = window.matchMedia('(max-width: 820px)');
    function closeAll(except) {
      spots.forEach(function (s) {
        if (s === except) return;
        s.classList.remove('is-open');
        s.removeAttribute('data-pinned');
        var d = s.querySelector('[data-hp-spot-dot]');
        if (d) d.setAttribute('aria-expanded', 'false');
      });
    }
    function setOpen(s, open) {
      s.classList.toggle('is-open', open);
      var dot = s.querySelector('[data-hp-spot-dot]');
      if (dot) dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      var pop = s.querySelector('.hod-bbt__pop');
      if (pop) pop.style.transform = '';
      if (open && pop) {
        // keep the card inside the photo: shift horizontally/vertically as needed and
        // slide the caret so it keeps pointing at the dot (desktop; the mobile box is too short)
        var box = root.querySelector('.hod-bbt__box').getBoundingClientRect();
        var pr = pop.getBoundingClientRect();
        var dx = 0, dy = 0;
        if (pr.left < box.left + 8) dx = box.left + 8 - pr.left;
        else if (pr.right > box.right - 8) dx = box.right - 8 - pr.right;
        if (window.matchMedia('(min-width: 821px)').matches) {
          if (pr.top < box.top + 8) dy = box.top + 8 - pr.top;
          else if (pr.bottom > box.bottom - 8) dy = box.bottom - 8 - pr.bottom;
        }
        pop.style.transform = 'translateY(calc(-50% + ' + dy + 'px)) translateX(' + dx + 'px)';
        pop.style.setProperty('--caret-y', 'calc(50% - ' + dy + 'px)');
      }
      if (!open) s.removeAttribute('data-pinned');
    }
    spots.forEach(function (s) {
      var dot = s.querySelector('[data-hp-spot-dot]');
      if (!dot) return;
      var closeBtn = s.querySelector('[data-hp-spot-close]');
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(s, false); });
      /* click: pin/unpin (second click closes) */
      dot.addEventListener('click', function () {
        /* mobile: the orb opens the theme's regular Quick View (hidden .hod-bbt__qv trigger →
           theme open-modal + custom.js loader) instead of the product card (Stas 9/1) */
        if (mqM.matches) {
          closeAll(null);
          var qv = s.querySelector('.hod-bbt__qv');
          if (qv) qv.click();
          return;
        }
        var pinned = s.hasAttribute('data-pinned');
        if (pinned) { setOpen(s, false); return; }
        closeAll(s); setOpen(s, true); s.setAttribute('data-pinned', '');
      });
      /* (hover-to-open removed 9/1 per Stas — orbs are click-only) */
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
    /* click anywhere outside an orb (even inside the photo) closes everything */
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-hp-spot]')) closeAll(null); });

    function addItems(items, btn) {
      if (!items.length) return;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        if (window.hodAnnounce) window.hodAnnounce(items.length > 1 ? items.length + ' items added to cart' : 'Added to cart');
        if (btn) { if (window.hodCheckHtml) { btn.innerHTML = window.hodCheckHtml('Added'); } else { btn.textContent = 'Added'; } setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000); }
      }).catch(function () {
        if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
      });
    }
    root.querySelectorAll('[data-hp-spot-add]').forEach(function (b) {
      b.addEventListener('click', function () { addItems([{ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 }], b); });
    });
    var all = root.querySelector('[data-hp-bbt-addall]');
    if (all) all.addEventListener('click', function () {
      var items = spots.map(function (s) { var b = s.querySelector('[data-hp-spot-add]'); return b ? { id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 } : null; }).filter(Boolean);
      addItems(items, all.querySelector('[data-hp-bbt-addall-label]') || all);
    });
  });
})();
